import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import { tabletQuery } from '@globals/themes/themeConstants'
import StandardPageLayout from '@layouts/standardPageLayout'
import useMediaQuery from '@mui/material/useMediaQuery'
import RouteLoading from '@shared/routing/RouteLoading'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const MeRoute = lazyWithRetries(() => import('../me'))
const MemberProfileRoute = lazyWithRetries(() => import('../memberProfile'))
const MeMobileRoute = lazyWithRetries(() => import('./mobile'))

const MeRouteWrapper = () => {
  const isTablet = useMediaQuery(tabletQuery)

  if (isTablet) {
    return (
      <Suspense fallback={<RouteLoading />}>
        <MeMobileRoute />
      </Suspense>
    )
  }

  return (
    <StandardPageLayout elementId="meRoute" maxWidth={1080}>
      <Suspense fallback={<RouteLoading />}>
        <MeRoute />
      </Suspense>
    </StandardPageLayout>
  )
}

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.me(),
    element: <MeRouteWrapper />,
  },
  {
    path: AppPaths.tenant.memberProfile(':tenantMemberId'),
    element: (
      <StandardPageLayout elementId="memberProfileRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <MemberProfileRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
